import React, { useState } from 'react';
import { ReactComponent as ProfilIcon } from 'assets/icons/profile_circle.svg';
import Button from 'components/customDesign/Button';
import erlClient from 'services/clients';
import fonts from 'styles/typography.module.css';
import { Dialog, IconButton } from '@mui/material';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface Props {
  isOpen: boolean;
  close: () => void;
  member: string;
}

const PendingInvitationDialog: React.FC<Props> = ({ isOpen, close, member }) => {
  const [invitationSent, setInvitationSent] = useState(false);
  const [invitationLoading, setInvitationLoading] = useState(false);
  const resendInvitation = async (email: string) => {
    try {
      setInvitationLoading(true);
      await erlClient.put(`/core/api/v1/auth/company/invitation/${email}`);
      setInvitationSent(true);
      setInvitationLoading(false);
    } catch {
      // eslint-disable-next-line no-console
      console.error('Cannot resend mail');
      setInvitationLoading(false);
    }
  };

  const [invitationRevoked, setInvitationRevoked] = useState(false);
  const [revokeLoading, setRevokeLoading] = useState(false);
  const revokeInvitation = async (email: string) => {
    try {
      setRevokeLoading(true);
      await erlClient.delete(`/core/api/v1/auth/company/invitation/${email}`);
      setInvitationRevoked(true);
      setRevokeLoading(false);
    } catch {
      // eslint-disable-next-line no-console
      console.error('Cannot revoke invitation');
      setRevokeLoading(false);
    }
  };
  const onClose = () => {
    setInvitationRevoked(false);
    close();
  };
  if (invitationRevoked) onClose();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className={fonts.font}
      classes={{ paper: 'flex flex-col p-8 items-center gap-4 relative' }}
    >
      <div className="absolute top-0 right-0">
        <IconButton onClick={onClose}>
          <XMarkIcon className="h-5" />
        </IconButton>
      </div>
      <ProfilIcon className="flex-shrink-0" />
      <h1 className="text-center font-bold">Invitation</h1>
      <h5 className="text-center text-gray-500">{member}</h5>
      <div className="flex flex-col items-center">
        <Button
          classes={{ root: 'w-[250px]' }}
          onClick={() => resendInvitation(member)}
          success={invitationSent}
          isLoading={invitationLoading}
        >
          {invitationSent ? 'Sent' : 'Resend member invitation'}
        </Button>
        <div>
          <h5
            className="text-gray-700 underline cursor-pointer"
            onClick={() => !revokeLoading && revokeInvitation(member)}
          >
            Revoke invitation
          </h5>
        </div>
      </div>
    </Dialog>
  );
};

export default PendingInvitationDialog;
